<div class="calendar-time">
    <span *ngIf="!event.nonTimed"
          data-automation-e2e-selector="calendarTime">
        {{formattedReleaseTime}}
    </span>
</div>
<div class="calendar-timeline"
     [ngClass]="{'current': this.current}">
</div>
<div class="calendar-name"
     [ngClass]="{'future': isFuture, 'current': this.current}"
     (click)="selectEvent()"
     data-automation-e2e-selector="calendarName">
    {{event.name}}
</div>